export interface CollectionItem {
  id: number;
  slug: string;
  name: string;
  description: string;
  image: string;
  images?: string[];
  category: string;
  pieces: string;
  price: string;
}

export const collectionsData: CollectionItem[] = [
  {
    id: 49,
    slug: "florentine-heritage-console",
    name: "The Florentine Heritage Console",
    description: "Crafted as a bespoke commission, this console reflects timeless artistry through its hand-painted European scene panels and refined carved detailing. Designed for interiors that value heritage, each element is carefully constructed to deliver both presence and permanence as a statement piece for formal living spaces.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/ba9cdb49-db34-4c73-8654-859e7fe8bb66_custom-order-1-1.jpeg?v=f9ada90645f36a29023cbecaf257fd7f",
    images: [
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/ba9cdb49-db34-4c73-8654-859e7fe8bb66_custom-order-1-1.jpeg?v=f9ada90645f36a29023cbecaf257fd7f",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/ca16f609-a6e1-4fc0-b741-72c944c7d11f_custom-order-1-2.jpeg?v=66f4b875e18d0494d0670d555daf8741",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/f87c7ae1-b015-442b-be6b-dea365bc839d_custom-order-1-3.jpeg?v=31ba26fd4d0339aae5c9edd04dff35af",
    ],
    category: "Custom Orders",
    pieces: "Bespoke",
    price: "Rs. —",
  },
  {
    id: 50,
    slug: "grand-atelier-sideboard",
    name: "The Grand Atelier Sideboard",
    description: "A bespoke sideboard distinguished by elaborate gold-leaf floral carvings and a commanding mirror frame. Crafted as a unique commission for interiors that celebrate European heritage, this piece balances ornamental grandeur with functional elegance.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/6104b3fb-cb3a-4dd6-bd5a-804bd20e444c_custom-order-2-1.jpeg?v=17a6b818a0bac22fa4595706d5ab41db",
    images: [
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/6104b3fb-cb3a-4dd6-bd5a-804bd20e444c_custom-order-2-1.jpeg?v=17a6b818a0bac22fa4595706d5ab41db",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/1964cb3d-968f-4ede-a99b-b182bc35b270_custom-order-2-2.jpeg?v=9138aab02fa1eb368e135eeecd0cc71b",
    ],
    category: "Custom Orders",
    pieces: "Bespoke",
    price: "Rs. —",
  },
  {
    id: 51,
    slug: "imperial-reflection-mirror",
    name: "The Imperial Reflection Mirror Frame",
    description: "This bespoke mirror frame cabinet unites a hand-painted pastoral scene with reflective elegance below. Crafted as a singular commission, it brings heritage character and artistic depth to refined interiors seeking both beauty and permanence.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/7c4c86cd-c300-428c-adec-f59bb828099f_custom-order-3-1.jpeg?v=f04997be9710daafeb3817ecc21df674",
    category: "Custom Orders",
    pieces: "Bespoke",
    price: "Rs. —",
  },
  {
    id: 52,
    slug: "artisan-display-cabinet",
    name: "The Artisan Display Cabinet",
    description: "A compact yet commanding corner display unit featuring intricate spindle balustrades and carved floral panels. Crafted as a bespoke commission, this piece reflects timeless artistry and refined detailing for interiors that value heritage craftsmanship.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/e00fb52f-29e0-42b3-8fca-283f67abce1b_custom-order-4-1.jpeg?v=55fc9b4ef21ab1433efb3c01fd0fe1d9",
    category: "Custom Orders",
    pieces: "Bespoke",
    price: "Rs. —",
  },
  {
    id: 53,
    slug: "regal-dressing-console",
    name: "The Regal Dressing Console",
    description: "A tall glass-fronted display cabinet framed in carved mahogany, designed to showcase treasured collections with museum-worthy presence. Crafted as a bespoke commission for interiors that demand both elegance and permanence.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/e1611b6d-08d4-4d6e-9bed-73bde907efb8_custom-order-5-1.jpeg?v=8561b30e10a48220e9abae0c29049de3",
    category: "Custom Orders",
    pieces: "Bespoke",
    price: "Rs. —",
  },
  {
    id: 54,
    slug: "classic-heritage-storage",
    name: "The Classic Heritage Storage Unit",
    description: "A grand storage console crowned by an expansive mirror, featuring carved floral motifs and balanced proportions. Crafted as a bespoke commission, this piece delivers both presence and permanence for heritage-inspired interiors.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/1c1cc76f-23aa-464c-8ab9-21245755fcc2_custom-order-6-1.jpeg?v=52931f44cede053add32d39aceddc9df",
    category: "Custom Orders",
    pieces: "Bespoke",
    price: "Rs. —",
  },
  {
    id: 55,
    slug: "aurelia-heritage-armchair",
    name: "The Aurelia Heritage Armchair",
    description: "A refined expression of European craftsmanship, this armchair balances sculptural presence with everyday comfort. Each curve is shaped by hand to honour classical proportions, while the upholstery delivers a warmth that invites long conversation. Designed for interiors that value both beauty and permanence.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/cb88c659-fe73-4058-9daf-1c79cf5dbea8_signature-1-1.jpeg?v=1af49ba1af32f2701b717cfd42317305",
    category: "Signature Pieces",
    pieces: "Limited Edition",
    price: "On Request",
  },
  {
    id: 56,
    slug: "windsor-cane-accent-chair",
    name: "The Windsor Cane Accent Chair",
    description: "Light, elegant, and deeply rooted in tradition, this accent chair brings woven cane textures together with polished wood in a timeless silhouette. The balanced form reflects colonial heritage craftsmanship while offering versatile presence across both formal and relaxed interiors.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/f95aeb69-afe5-4b28-ab8e-3d22160a3c24_signature-2-1.jpeg?v=c21066af108cb9061d83b943bd10d0c2",
    category: "Signature Pieces",
    pieces: "Limited Edition",
    price: "On Request",
  },
  {
    id: 57,
    slug: "regent-lounge-sofa",
    name: "The Regent Lounge Sofa",
    description: "A commanding presence in any drawing room, this lounge sofa unites generous proportions with meticulous hand-finished detailing. Its deep cushions and balanced symmetry create an atmosphere of composed luxury, crafted for interiors that demand both comfort and elevated visual character.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/7f2ee730-c337-4bac-a2dc-62342e552c31_signature-3-1.jpeg?v=342a0abbd63fb2c2b4504fe1a7107401",
    images: [
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/7f2ee730-c337-4bac-a2dc-62342e552c31_signature-3-1.jpeg?v=342a0abbd63fb2c2b4504fe1a7107401",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/01ee8535-735e-400e-8eb5-8de456c42b40_signature-3-2.jpeg?v=518b4d8e47e280838e17a6dce2e5f0c3",
    ],
    category: "Signature Pieces",
    pieces: "Limited Edition",
    price: "On Request",
  },
  {
    id: 58,
    slug: "imperial-carved-salon-set",
    name: "The Imperial Carved Salon Set",
    description: "This complete salon arrangement brings together carved elegance and cohesive design language in one commanding ensemble. Each piece shares the same hand-carved motifs and refined proportions, creating a unified statement of heritage taste. Built for formal entertaining spaces that value permanence and presence.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/6e2f94f1-5a13-4374-b083-5beb8498f63a_signature-4-1.jpeg?v=6bba9f0eac4b35f9f98225a8d0c6a282",
    images: [
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/6e2f94f1-5a13-4374-b083-5beb8498f63a_signature-4-1.jpeg?v=6bba9f0eac4b35f9f98225a8d0c6a282",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/266d725c-0a9e-45c9-a449-8cca9fad3f56_signature-4-2.jpeg?v=555ddc768795bcf09b4b9b0c2c8bb8a3",
    ],
    category: "Signature Pieces",
    pieces: "Limited Edition",
    price: "On Request",
  },
  {
    id: 16,
    slug: "bedroom-bed-versailles-cane",
    name: "Versailles Cane Heritage Bed",
    description: "A refined expression of French heritage, this cane-backed bed blends delicate carving with timeless elegance. Crafted for interiors that celebrate softness, symmetry, and artisanal detail.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/d6191fdd-ad37-47cb-b26b-f0a514a2f221_Bed-1.jpeg?v=bc824356f97ba9d221b98003d23ebeb5",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 310,000",
  },
  {
    id: 17,
    slug: "bedroom-bed-windsor-upholstered",
    name: "Windsor Upholstered Classic Bed",
    description: "An understated statement of luxury, featuring a gracefully upholstered headboard and warm wood tones. Designed to bring balance, comfort, and enduring sophistication to the bedroom.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/734a1e62-9eeb-46e6-90a4-cf11fccf08fa_Bed-2.jpeg?v=6eb98af2f3d52a12dc39b9ce9d627a19",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 295,000",
  },
  {
    id: 18,
    slug: "bedroom-bed-regency-carved",
    name: "Regency Carved Panel Bed",
    description: "Defined by its intricate carved crest and solid structure, this piece reflects regal craftsmanship. A bold yet elegant centerpiece inspired by classical European design traditions.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/ef9306f8-5a04-4c29-8625-0c4dcfa23818_Bed-3.jpeg?v=7742dfd51fde03cad108774f27aa9816",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 335,000",
  },
  {
    id: 19,
    slug: "bedroom-bed-imperial-leatherback",
    name: "Imperial Leatherback Sleigh Bed",
    description: "A commanding presence with its sculpted sleigh form and cushioned leather panels. Built for grandeur, this bed embodies strength, luxury, and refined comfort.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/7866dc43-1388-4586-96ae-b571b65689bb_Bed-4.jpeg?v=909a83a35fa6ca4aaa840d94905a9360",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 345,000",
  },
  {
    id: 20,
    slug: "bedroom-bed-louis-xv-velvet",
    name: "Louis XV Velvet Frame Bed",
    description: "Inspired by French aristocracy, this bed features flowing curves and plush upholstery. A perfect harmony of softness and craftsmanship, designed for timeless interiors.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/b2dc7860-3aa5-49c6-8808-e72b61de7400_Bed-5.jpeg?v=6fff5b4985d8da47b05aa50990fb91b2",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 325,000",
  },
  {
    id: 21,
    slug: "bedroom-bed-heritage-manor",
    name: "Heritage Manor Panel Bed",
    description: "A classic wooden structure with balanced proportions and subtle detailing. This design reflects enduring craftsmanship suited for refined, traditional spaces.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/776ea5fd-a992-44b7-b957-c81430a2a4c8_Bed-6.jpeg?v=4a944a3a7fd61423f597c2077a649944",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 300,000",
  },
  {
    id: 22,
    slug: "bedroom-bed-victorian-estate",
    name: "Victorian Grand Estate Bed",
    description: "Rich in detail and presence, this bed captures the essence of Victorian luxury. Designed to elevate interiors with its bold structure and timeless artistry.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/77f1a9d2-b841-4956-b5b4-597227618ddf_Bed-7.jpeg?v=51bc3cae5028301fefae2bee72a64422",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 340,000",
  },
  {
    id: 23,
    slug: "bedroom-bed-regency-sleigh",
    name: "Classic Regency Sleigh Bed",
    description: "A smooth sleigh silhouette paired with warm wood finishes creates a sense of calm luxury. Ideal for interiors that value both comfort and classic form.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/0c71a1ef-769b-43c6-9895-98d5c838af86_Bed-8.jpeg?v=e28ea7dbd03f7840df9c34681646c61a",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 305,000",
  },
  {
    id: 24,
    slug: "bedroom-bed-royal-cane",
    name: "Royal Cane Panel Bed",
    description: "Blending woven cane textures with polished wood, this design reflects a refined colonial influence. Light, elegant, and deeply rooted in heritage craftsmanship.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/eca8a631-c569-44b3-88d3-3096500d6f45_Bed-9.jpeg?v=24a0fbc79958e9ed702b86be418344f2",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 320,000",
  },
  {
    id: 25,
    slug: "bedroom-bed-chesterfield-tufted",
    name: "Chesterfield Tufted Heritage Bed",
    description: "Featuring deep tufting and sculpted curves, this bed delivers a plush yet structured aesthetic. A luxurious statement piece for interiors that demand character and comfort.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/58bd0aa9-6c66-4179-96e5-896a95553edd_Bed-10.jpeg?v=462d4c0788f51ea733457a13b1d5020a",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 330,000",
  },
  {
    id: 26,
    slug: "bedroom-bed-edwardian-panel",
    name: "Edwardian Panel Heritage Bed",
    description: "A distinguished wooden frame defined by structured panel detailing and timeless proportions. Designed to reflect heritage elegance with a grounded, classic presence.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/f162601b-070f-4485-99db-adf308fb8860_bed-11.jpeg?v=a244c144cbf4438b0e54286a3006afb1",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 305,000",
  },
  {
    id: 27,
    slug: "bedroom-bed-french-regency-sleigh",
    name: "French Regency Sleigh Bed",
    description: "A graceful sleigh silhouette paired with refined woodwork creates a balanced expression of French elegance. Crafted for interiors that embrace softness and symmetry.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/9a19c5ed-aeaf-4d41-aebe-45b0fa103f30_Bed-12.jpeg?v=d2a9a3d99d083b77fb5aed7cb516010a",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 320,000",
  },
  {
    id: 28,
    slug: "bedroom-bed-contemporary-platform",
    name: "Contemporary Heritage Platform Bed",
    description: "A modern interpretation of heritage design, featuring clean lines and a grounded structure. Perfect for spaces that blend simplicity with timeless warmth.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/00710b01-2cb8-4dd1-a302-3ac367f66eaa_Bed-13.jpeg?v=aa0994e2d5c81e5ac3123ad81ae7cfd9",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 275,000",
  },
  {
    id: 29,
    slug: "bedroom-bed-victorian-carved-estate",
    name: "Victorian Carved Estate Bed",
    description: "Rich carvings and deep wood tones define this stately piece. A bold reflection of Victorian craftsmanship, designed to command attention with refined artistry.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/e7929f67-f205-4869-b322-f749bf2317d3_Bed-14.jpeg?v=8efbc2999268a7de0239559705cd3e62",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 345,000",
  },
  {
    id: 30,
    slug: "bedroom-bed-louis-xvi-classic",
    name: "Louis XVI Classic Frame Bed",
    description: "Elegant symmetry and subtle detailing highlight this refined frame. Inspired by French classical design, it brings sophistication and balance to traditional interiors.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/413f840d-07bf-4160-b506-1317ec203d54_Bed-15.jpeg?v=74d80e0d84a2cf39d8ae106ed47c7a49",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 330,000",
  },
  {
    id: 31,
    slug: "bedroom-bed-chesterfield-grand",
    name: "Chesterfield Upholstered Grand Bed",
    description: "Deeply cushioned panels and a commanding structure define this luxurious centerpiece. Crafted for those who appreciate comfort elevated by timeless design.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/cdaa34ee-80e2-457c-95e5-52818fb3646e_Bed-16.jpeg?v=49df26a9322b154e63037c38a12173b8",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 350,000",
  },
  {
    id: 32,
    slug: "bedroom-bed-manor-classic",
    name: "Manor House Classic Panel Bed",
    description: "A solid wooden structure with refined panel work and balanced proportions. Designed to bring enduring character and warmth into heritage-inspired spaces.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/8a6827a6-3682-43b1-be7f-68123af9c87e_Bed-17.jpeg?v=cf8c095627af53297b8d3724f282ef26",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 295,000",
  },
  {
    id: 33,
    slug: "bedroom-bed-imperial-sleigh-signature",
    name: "Imperial Sleigh Signature Bed",
    description: "A bold sleigh form enhanced with rich finishes and subtle detailing. This piece embodies timeless grandeur with a refined, luxurious presence.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/f5a583f0-a700-4978-9cb3-48f2240766cb_Bed-18.jpeg?v=75192626179f307edd6c548e3826c904",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 340,000",
  },
  {
    id: 34,
    slug: "bedroom-bed-classic-upholstered",
    name: "Classic Heritage Upholstered Bed",
    description: "A harmonious blend of soft upholstery and structured wood framing. Designed for comfort and elegance, offering a timeless addition to refined interiors.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/fce0989c-7dd1-48fe-8ae1-87118f4c76dc_Bed-19.jpeg?v=234266781b92a796be4201989ccb0420",
    category: "Bedroom",
    pieces: "1 Piece",
    price: "Rs. 285,000",
  },
  {
    id: 35,
    slug: "din-001",
    name: "Royal Heritage Dining Set",
    description: "Crafted from solid hardwood with refined joinery, this dining set reflects the enduring elegance of traditional heritage design. A timeless centerpiece for gatherings that demand both beauty and substance.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/35d585f8-6e61-4396-868c-7627af3a834d_Dining-1.jpeg?v=f13ae27f007fc5352927dcdbf3b614e4",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 285,000",
  },
  {
    id: 36,
    slug: "din-002",
    name: "Imperial Carved Dining Collection",
    description: "Intricate hand-carved detailing adorns every surface of this collection, showcasing the mastery of artisan woodworking. Built to elevate formal dining spaces with quiet grandeur.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/22d83833-5ea0-4c1e-8020-6666b60c0ffc_Dining-2.jpeg?v=31da5cea14f61ad69f83d21868ce9c94",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 320,000",
  },
  {
    id: 37,
    slug: "din-003",
    name: "Victorian Grand Dining Ensemble",
    description: "A commanding ensemble defined by rich wood tones and classical proportions. Designed for those who appreciate the weight of history expressed through solid craftsmanship.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/48acd214-b38a-4ab3-9dc4-b6002353aacd_Dining-3.jpeg?v=164f2c4176d37d9f796249a26ed0c4b3",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 395,000",
  },
  {
    id: 38,
    slug: "din-004",
    name: "Regal Artisan Dining Table",
    description: "The Regal Artisan table pairs sculptural carved legs with a polished surface of exceptional grain. A singular statement of refined taste rooted in generational woodworking tradition.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/bec0709b-1242-4aa3-8f77-9e81326fb77a_Dining-4.jpeg?v=bc2f06d69739bc69333706260bc0734d",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 240,000",
  },
  {
    id: 39,
    slug: "din-005",
    name: "Classic Walnut Dining Suite",
    description: "Warm walnut tones and balanced symmetry define this understated suite. Ideal for interiors that honour simplicity without compromising on heritage quality.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/9eab8645-6be8-4e5a-b1f0-ef190be3fc7d_Dining-5.jpeg?v=80c1f1768d59cfe2f7b1bad9ad43c955",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 185,000",
  },
  {
    id: 40,
    slug: "din-006",
    name: "Heritage Oak Dining Collection",
    description: "A robust oak collection shaped by time-honoured techniques and meticulous hand-finishing. Built to anchor dining rooms with character, warmth, and lasting presence.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/8dc99a86-d139-440b-bc20-c93db05e3b1f_Dining-6.jpeg?v=c1ead0fb19860966a2a997995b60210f",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 350,000",
  },
  {
    id: 41,
    slug: "din-007",
    name: "Majestic Carved Dining Set",
    description: "Bold proportions and ornate crest detailing distinguish this majestic set. Crafted for estates and discerning homes where dining is an occasion of distinction.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/fcd6f642-cf7a-41ed-88f7-de371e38d2df_Dining-7.jpeg?v=4ca00c8fbe2e1a9570e3e59addcb4e93",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 420,000",
  },
  {
    id: 42,
    slug: "din-008",
    name: "Sovereign Teak Dining Ensemble",
    description: "Sustainably sourced teak meets heritage carving in this balanced ensemble. Designed to bring natural richness and timeless form to contemporary and classical interiors alike.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/d9e6cce5-2329-4533-806c-0d74066d512c_Dining-8.jpeg?v=873b85c5b803443dcbe051025277bcb1",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 265,000",
  },
  {
    id: 43,
    slug: "din-009",
    name: "Aristocrat Panel Dining Suite",
    description: "Paneled detailing and subtle brass accents lend this suite an aristocratic air. A refined choice for collectors of understated luxury and enduring design.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/9ee327f6-edbf-43b8-bd44-e7cc4842f9b9_Dining-9.jpeg?v=c0b831ea9ac3f579a46f152ed9650766",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 310,000",
  },
  {
    id: 44,
    slug: "din-010",
    name: "Estate Mahogany Dining Collection",
    description: "Deep mahogany polish and elaborate carved motifs define this estate-worthy collection. A final statement of heritage grandeur for the most distinguished dining halls.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/cb0df03c-ec8e-462b-a105-bd950a2dc963_Dining-10.jpeg?v=c18aea416ce3ca9b97c78a4e77fd02e9",
    category: "Dining",
    pieces: "1 Piece",
    price: "Rs. 450,000",
  },
  {
    id: 70,
    slug: "aurelia-heritage-settee",
    name: "The Aurelia Heritage Settee",
    description: "A graceful expression of classical European seating, the Aurelia Heritage Settee blends sculptural woodwork with refined upholstery. Handcrafted to evoke timeless elegance, it serves as both a functional seating piece and a statement of heritage luxury.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/9bbcadf0-3e41-44d6-8af8-0828b3695f86_settee.jpeg?v=4ed9c6a101cdf6b6bed89cf693a57db7",
    category: "Living",
    pieces: "1 Piece",
    price: "Rs. 255,000",
  },
  {
    id: 45,
    slug: "sofa-windsor-heritage",
    name: "Windsor Heritage Lounge Set",
    description: "A refined living ensemble crafted for timeless interiors. Featuring plush seating, balanced proportions, and soft neutral upholstery, this set delivers both comfort and sophistication. Designed as a complete seating arrangement ideal for formal living spaces. Seating capacity: 5 persons.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/8f14b2ea-70a0-4b54-ba71-1636aaf274ac_Sofa-1-5S-1.jpeg?v=bc0be77cacd38e7a61b38c86d33da907",
    images: [
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/8f14b2ea-70a0-4b54-ba71-1636aaf274ac_Sofa-1-5S-1.jpeg?v=bc0be77cacd38e7a61b38c86d33da907",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/1ead70d7-f0e8-4c5a-a2de-d9f897da76c0_Sofa-1-5S-2.jpeg?v=fa2cd416512b94b90fbdb5121423b961",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/65949555-c1b7-424d-b5b3-ad86f0acca86_Sofa-1-5S-3.jpeg?v=049ce6b3efbcf81b3935409faed5cddd",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/c2e33047-a593-4ace-b92a-4b9c7d5c5c59_Sofa-1-5S-4.jpeg?v=69426d76fbf2d439e3f6cce03eeade86",
    ],
    category: "Living",
    pieces: "1 Piece",
    price: "Rs. 295,000",
  },
  {
    id: 46,
    slug: "sofa-regency-classic",
    name: "Regency Classic Living Suite",
    description: "An elegant composition of form and comfort, defined by soft curves, premium upholstery, and a balanced seating layout. This suite enhances interiors with a calm, luxurious presence while offering practical everyday comfort. Seating capacity: 5 persons.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/ba606d0f-5d3c-435d-ba9b-06653175972d_Sofa-2-5S-1.jpeg?v=b8250a032ac1686d90a68d47d086c9e5",
    images: [
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/ba606d0f-5d3c-435d-ba9b-06653175972d_Sofa-2-5S-1.jpeg?v=b8250a032ac1686d90a68d47d086c9e5",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/12d4a19a-2866-4a39-b8b6-44a83495e593_Sofa-2-5S-2.jpeg?v=1e469e5ff959f27e1f290496c8a1db41",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/3f9e4702-a8f5-4f23-9c0a-c27c1b444728_Sofa-2-5S-3.jpeg?v=4e2c0db2afda510f30f05569de74fa04",
      "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/397a7699-4a1f-48f5-a1a4-099cd0ced15d_Sofa-2-5S-4.jpeg?v=8b5170e205d16f9f8355c355c0090d98",
    ],
    category: "Living",
    pieces: "1 Piece",
    price: "Rs. 285,000",
  },
  {
    id: 47,
    slug: "sofa-cambridge-compact",
    name: "Cambridge Compact Sofa",
    description: "A compact yet refined sofa designed for intimate living spaces. Its clean lines, soft cushioning, and classic proportions make it a versatile piece that blends seamlessly into both traditional and modern interiors. Seating capacity: 4 persons.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/f4a7a808-9edf-4538-97a0-a1500ab47c92_Sofa-3-4S-1.jpeg?v=9dfd75d5a675c0b302a38ee2485b9a86",
    category: "Living",
    pieces: "1 Piece",
    price: "Rs. 175,000",
  },
  {
    id: 48,
    slug: "sofa-victorian-carved",
    name: "Victorian Carved Lounge Sofa",
    description: "A statement piece inspired by classic European craftsmanship. Featuring detailed woodwork and elegant upholstery, this sofa brings heritage character and elevated comfort to any refined living environment. Seating capacity: 5 persons.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/aaa0224c-dacf-4251-8ef7-f5c97c5e7a9f_Sofa-4-5S-1.jpeg?v=67eb29b5ca05f430462e0ea27d5f00ef",
    category: "Living",
    pieces: "1 Piece",
    price: "Rs. 265,000",
  },
];

export const collectionCategories = ["All", "Living", "Bedroom", "Dining", "Custom Orders", "Signature Pieces"];

export const categoryShowcaseItems = collectionCategories
  .filter((c) => c !== "All")
  .map((cat) => collectionsData.find((item) => item.category === cat)!)
  .filter(Boolean);